module.exports = __webpack_public_path__ + "img/identityChecked3.8ad8dfc2.png";